module.exports = __webpack_public_path__ + "static/media/1Asset-14SDRs.60ca5718.png";